import React from "react";
import { Grid } from "@material-ui/core";
import OpenWithIcon from "@material-ui/icons/OpenWith";
import SimpleDialogDemo from "../../../Modals/SimpleDialog";
import InventoryItemForm from "./InventoryItemForm";

export default function UpdateInventoryItem({ itemKey, item }) {
  return (
    <Grid container direction="column" alignItems="center">
      <Grid item xs={12}>
        <SimpleDialogDemo buttonText={"Editar"} icon={<OpenWithIcon />} fullScreen={true}>
          <InventoryItemForm itemKey={itemKey} existingItem={item} />
        </SimpleDialogDemo>
      </Grid>
    </Grid>
  );
}
